/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef, useImperativeHandle, forwardRef} from "react";
import useIsMobile from "../../hooks/useIsMobile";

const VideoTranscript =  forwardRef ( ({ transcript }, ref) => {
  const [open, setOpen] = useState(false);
  const transcriptRef = useRef(null);
  
  useImperativeHandle(ref, () => ({
    scrollTranscriptTop() {
      transcriptRef.current.scrollTop = 0;
    }
  }));

  const isMobile = useIsMobile();

  const transcriptHeight = isMobile ? 'h-[360px]' :'h-[225px]'

  return (
    <div className={`order-2 lg:order-3 mt-3 lg:mt-6 col-span-full relative`}>
      
      <div className="text-center text-primary text-[12px] text-watermelon">
        <i>TRANSCRIPT</i>
      </div>

      <div 
        onClick={() => {setOpen(!open)}}
        className="gtm-accordion relative flex py-2 lg:mt-3 lg:pt-1 items-center"
        track-label="Transcript"
      >
        <div className="flex-grow border-t border-white opacity-50"></div>
        <a onClick={e => e.preventDefault()} href="/toggle-the-transcript" className={`toggleButton w-4 h-4 block rounded-xl ${open ? 'minus' : ''}`}>
          <span></span>
          <span></span>
        </a>
        <div className="flex-grow border-t border-white opacity-50"></div>
      </div>

      <div ref={transcriptRef} className={`${open ? 'h-auto' : 'h-[0px]'} transcript-copy transition-height duration-500 ease-in-out overflow-y-none pr-4 lg:pr-2 mt-4 transcript`}>
        {transcript}
      </div>
      
    </div>
  );
});

export default VideoTranscript;